import React from "react";

export type Props = {
  name: string;
  className?: string;
  outlined?: boolean;
  onClick?: () => void;
};

export const Icon: React.FC<Props> = ({
  name,
  className,
  outlined,
  ...rest
}) => {
  const materialIconClass = !outlined
    ? "material-icons"
    : "material-icons-outlined";
  return (
    <i className={`${materialIconClass} ${className || ""}`} {...rest}>
      {name}
    </i>
  );
};
